@if(isLoading) {
<div class="loading-overlay">
  <div class="loading-spinner">
    <mat-spinner></mat-spinner>
  </div>
</div>
}

<div class="main-wrapper">
  <div class="content">
    <div class="form-container">
      <img
        src="assets/svg/logos/saude_conectada_logo.svg"
        alt="Logo Saúde Conectada"
        class="logo"
      />

      <div class="texts">
        <h2>Confirme seu código.</h2>
        <p>Insira abaixo o código que enviamos para o e-mail {{email}}.</p>
      </div>

      <div class="form-fields">
        <div class="code-inputs">
          <input
            *ngFor="let digit of digits; let i = index"
            maxlength="1"
            type="text"
            (input)="onInput($event, i)"
            (keydown)="onKeyDown($event, i)"
            [value]="codigo[i] || ''"
            autocomplete="off"
            autofocus="{{ i === 0 }}"
            inputmode="numeric"
            pattern="[0-9]*"
          />
        </div>

        <div class="spacer" style="height: 1em;"></div>
        <p class="info-text">
          O código é válido por <b>1 hora</b>. Ainda não recebeu ou o tempo
          expirou?
          <a
            href="#"
            (click)="reenviarCodigo($event)"
            [class.resend_disabled]="!podeReenviar"
            [attr.aria-disabled]="!podeReenviar"
          >
            Clique para reenviar!
          </a>

          <span *ngIf="!podeReenviar" class="timer-text">
            (Aguarde <b>{{ timerSeconds }} segundos</b> para uma nova
            solicitação)
          </span>
        </p>

        <div class="spacer" style="height: 2em"></div>
        <button
          matButton="filled"
          style="width: 100%"
          class="submit-button"
          [disabled]="codigo.length < 6"
          (click)="confirmarCodigo()"
        >
          Validar código
        </button>
      </div>

      <div class="return" (click)="voltarParaLogin()">
        <img src="assets/svg/icons/arrow_left.svg" alt="" />
        <p>Voltar para login</p>
      </div>

      <img
        src="assets/svg/logos/sesi_logo.svg"
        alt="Logo SESI"
        class="logo-sesi"
      />
    </div>
  </div>
</div>
